import util from '../util'

let controller = 'LimiteOperador'

export default Object.assign({}, util.GetCrud(controller, ['post', 'put', 'get', 'getall', 'persist', 'delete']), {
  HistoricoLimiteOperador: function (dto) {
    return util.Axios.GetAll(controller + '/LogsLimiteOperador', dto)
  }
})
